const getters = {
	sidebar: state => state.app.sidebar,

	expires: state => state.user.expires,
	token: state => state.user.token,
	companyName: state => state.user.companyName,
	permissions: state => state.user.permissions,
	hasInfo: state => state.user.hasInfo,

	pagination: state => state.com.pagination,
	autarkyList: state => state.com.autarkyList,
	participateList: state => state.com.participateList,
	areaTableLoading: state => state.com.areaTableLoading,
	areaTableFilter: state => state.com.areaTableFilter,
	circuitTableLoading: state => state.com.circuitTableLoading,
	circuitTableFilter: state => state.com.circuitTableFilter,
}
export default getters
